import React from "react";
import {  FaHeart, FaComment } from "react-icons/fa";
import { IoCreate } from "react-icons/io5";

function Posts() {
  return (
    <div
      className="h-100 content-wrapper"
      style={{
        backgroundColor: "#F7F7F7",
        borderRadius: "10px",
        padding: "20px",
      }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <h5 className="text-start fw-bold formal-text mb-4">New Feeds</h5>
        <div>
        <span
            className="rounded-circle d-inline-flex justify-content-center align-items-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e3e3e3",
              marginRight: "10px",
            }}
          >
            <IoCreate  size={18} style={{color: "#263F86"}}/>
          </span>
          
          <span
            className="rounded-circle d-inline-flex justify-content-center align-items-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e3e3e3",
              marginRight: "10px",
            }}
          >
            <FaHeart size={18} style={{color: "#263F86"}}/>
          </span>
          <span
            className="rounded-circle d-inline-flex justify-content-center align-items-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e3e3e3",
            }}
          >
            <FaComment size={18} style={{color: "#263F86"}}/>
          </span>
          
        </div>
      </div>
      <p>There is no more post to show.</p>
    </div>
  );
}

export default Posts;
